//@flow
import React, { type Node, Component } from 'react';
import EmptyTable from '../../../components/EmptyTable';

type Props = {
  failedLoad: boolean,
  children: Node,
  tableBodyOptions: {
    model: string
  }
};
export default class RenderTable extends Component<Props> {
  render() {
    return this.props.failedLoad ? (
      <table>
        <EmptyTable
          error
          columns={7}
          model={this.props.tableBodyOptions.model}
        />
      </table>
    ) : (
      this.props.children
    );
  }
}
